import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

const state = {};

const getters = {};

const mutations = {};

const actions = {
    getCentrosResponsabilidade(context, dados) {
        if((!dados.pagina) || (!dados.quantidadePorPagina)) {
            dados.pagina = 1;
            dados.quantidadePorPagina = 25;
        }
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("centrosResponsabilidade/access/listar", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getCentrosResponsabilidadeBox(context, filtros) {
        filtros.componente = "SearchBoxCentrosResponsabilidade";

        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("centrosResponsabilidade/access/listaBox", filtros).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getCentrosResponsabilidadePorNivel(context, $codigoCentroResponsabilidadeSuperior) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("centrosResponsabilidade/access/listarPorNivel", {CODIGO_CENTRO_RESPONSABILIDADE_SUPERIOR: $codigoCentroResponsabilidadeSuperior}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getCentroResponsabilidade(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("centrosResponsabilidade/access/obter", {ID_CENTRO_RESPONSABILIDADE: dados.id, componente: dados.componente}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getCentroResponsabilidadeSimples(context, idCResponsabilidade) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("centrosResponsabilidade/access/obterSimples", {ID_CENTRO_RESPONSABILIDADE: idCResponsabilidade}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    deleteCentroResponsabilidade(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("centrosResponsabilidade/access/excluir", {ID_CENTRO_RESPONSABILIDADE: dados.id, componente: dados.componente}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    postCentroResponsabilidade(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("centrosResponsabilidade/access/salvar", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    getCRespCategoriasPorNivel(context, id) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("centrosResponsabilidade/access/listarCRespCategoriasPorNivel", id).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};